import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
@Component({
  selector: 'app-view-animal-diagnostic',
  templateUrl: './view-animal-diagnostic.component.html',
  styleUrls: ['./view-animal-diagnostic.component.css']
})
export class ViewAnimalDiagnosticComponent implements OnInit {
  getanimaldiagnosticviewApi:any;
  testdate:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit(){
    let DiagnosticId = sessionStorage.getItem('diagnosticId');
    this.getanimaldiagnosticviewApi= "/animal_management/diagnostics/"+DiagnosticId;
    (await this.commonService.getApi(this.getanimaldiagnosticviewApi)).subscribe(
      res => { 
        console.log(res.data);
        var date=res.data.tnam_dgn_date_of_test;
         this.testdate = date.split('T');
        $("#Diagnostictest").text(res.data.tnam_dgn_diagnostics_test_name),
       $("#Description").text(res.data.tnam_dgn_diagnostics_description)
      })
    }
      backnavigate(){
        this.router.navigate([this.returnUrl]);
      }
  }


